module.exports = "../fonts/HelveticaNeueLTW01-55Roman.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-55Roman.woff2
// module id = wPuX
// module chunks = 1